import { Routes, Route, Navigate } from 'react-router-dom';
import { EventsProvider } from './context/EventsContext';
import { AnalysisProvider } from './context/AnalysisContext';
import { DashboardProfileProvider } from './context/DashboardProfileContext';
import { DashboardHome } from './home/DashboardHome';
import EventFormPage from './home/EventFormPage';
import EventDashboardApp from './EventDashboardApp';
import { AnalysisHome } from './analysis/AnalysisHome';
import AnalysisDetail from './analysis/AnalysisDetail';
import AnalysisFormPage from './analysis/AnalysisFormPage';
import { BlogHome } from './blog/BlogHome';
import BlogEditorPage from './blog/BlogEditorPage';
import AppBuildPage from './app/AppBuildPage';

export default function DashboardRouter() {
  return (
    <DashboardProfileProvider>
      <EventsProvider>
        <AnalysisProvider>
          <Routes>
            <Route index element={<DashboardHome />} />
            <Route path="events/new" element={<EventFormPage />} />
            <Route path="events/:eventId/edit" element={<EventFormPage />} />
            <Route path="events/:eventId" element={<EventDashboardApp />} />
            <Route path="analysis/new" element={<AnalysisFormPage />} />
            <Route path="analysis/:analysisId/edit" element={<AnalysisFormPage />} />
            <Route path="analysis" element={<AnalysisHome />} />
            <Route path="analysis/:analysisId" element={<AnalysisDetail />} />
            <Route path="blog" element={<BlogHome />} />
            <Route path="blog/new" element={<BlogEditorPage />} />
            <Route path="blog/:postId/edit" element={<BlogEditorPage />} />
            <Route path="app" element={<AppBuildPage />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AnalysisProvider>
      </EventsProvider>
    </DashboardProfileProvider>
  );
}
